export default "__VITE_ASSET__DlmNQHro__"